<svg class="lu-icon" *ngIf="iconUrl; else fontAwesomeTemp" [ngClass]="customClass" aria-hidden="true">
	<use [attr.xlink:href]="iconUrl"></use>
</svg>
<ng-template #fontAwesomeTemp>
	<i [ngClass]="[type, 'fa-' + iconName]" aria-hidden="true" *ngIf="!!iconName"></i>
</ng-template>
